package app.components

import dev.fritz2.core.RenderContext
import dev.fritz2.core.value
import dev.fritz2.core.values

fun RenderContext.projectStepInputText(
    label: String,
    value: String,
    className: String = "border rounded p-1 w-11/12 dark:bg-gray-800 dark:border-gray-600 dark:text-white dark:placeholder-gray-400",
    onChange: (String) -> Unit
) {
    div {
        p("text-sm") { +label }
        input(className) {
            value(value)
            changes.values() handledBy { newValue ->
                onChange(newValue)
            }
        }
    }
}
